import _ from 'lodash';

export default class FormHelper {
  static set(object, path, value, callback) {
    _.set(object, path, value);
    callback(object);
  }
}

export const genFormItemAtrribute = (
  name,
  label = null,
  valuePropName = 'value'
) => {
  // label = label || name
  return {
    name: name,
    label: label,
    valuePropName: valuePropName,
  };
};



// WEBPACK FOOTER //
// ./src/libs/FormHelper.js